import { toPairs } from 'lodash';
export function encodeObjToStr(obj) {
  var join = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var arr = toPairs(obj).map(function (item) {
    return "".concat(item[0], "=").concat(item[1]);
  });
  return arr.join(' ');
}